import {Accordion, AccordionDetails, AccordionSummary, Typography} from '@mui/material'
import {FC, ReactElement, useState} from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

type Props = {
  children: ReactElement | null
  Header?: React.FC
}

export const AccordianBancas: FC<Props> = ({children, Header}) => {
  const [expanded, setExpanded] = useState(true)
  return (
    <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='panel1a-content'
        id='panel1a-header'
      >
        {Header ? (
          <Header />
        ) : (
          <Typography sx={{fontSize: '16px', fontWeight: 600}}>Thông tin gói bảo hiểm</Typography>
        )}
      </AccordionSummary>
      <AccordionDetails>
        <div className='insurance-info'>{children}</div>
      </AccordionDetails>
    </Accordion>
  )
}
